/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-03-07 13:25:19
 * @LastEditors: shiguang
 * @LastEditTime: 2024-03-12 20:34:30
 * @FilePath: /ckb-official-website-fed/src/container/Home/modules/joinUs.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { atomRoutePathLangPre } from '@/atom/atomRoutePathLangPre';
import { strings } from '@/i18n/i18n';
import useDeviceType, { ENUM_DEVICE_TYPE } from '@/hooks/useDeviceType';
import { maskImgH5, maskImgPC } from '../config';
import './joinUs.scss';

const JoinUS = () => {

    const nav = useNavigate();
    const routePathLangPre = useAtomValue(atomRoutePathLangPre);
    const { deviceType } = useDeviceType();

    const goToNav = () => {
        nav(`/${routePathLangPre}/joinus`);
    };
    return (
        <div className="section sectionJoinUs" style={{ width: '100vw', height: 'calc(var(--vh) * 100)', position: 'relative' }}>
            <div
                style={{ position: 'relative', height: 'calc(var(--vh) * 100)' }}
            >


                <img
                    src="https://static-s.theckb.com/BusinessMarket/offcialWebsite/culture_bg_pc_joinus.png"
                    className="section-item-img"
                    style={{
                        width: '100vw',
                        height: 'calc(var(--vh) * 100)',
                        objectFit: 'cover',
                        objectPosition: '0 100%'
                    }} alt=""
                />


            </div>
            <img
                src={deviceType === ENUM_DEVICE_TYPE.MOBILE ? maskImgH5 : maskImgPC}
                style={{
                    width: '100%',
                    height: 'calc(var(--vh) * 100)',
                    objectFit: 'cover',
                    position: 'absolute',
                    zIndex: 22,
                    top: 0,
                    left: 0

                }} alt=""
            />


            <div className="sectionJoinUs-content">
                <div className="sectionJoinUs-title">{strings.t('用年轻人的方式改变世界')}</div>
                <div className="sectionJoinUs-tip">{strings.t('更运动，更开放，更灵活')}</div>
                <div className="sectionJoinUs-btn" onClick={goToNav}>{strings.t('加入我们')}</div>
            </div>
        </div>
    );


};

export default JoinUS;